import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_483: DocMigration = {
  maxSchemaVersion: "0.0.483",
  description: "Add DocEntityBase entityType field to options",
  apply(json: any) {
    for (const id in json.optionSets) {
      json.optionSets[id] = migrateOptionSet(json.optionSets[id]);
    }

    return json;
  },
};

function migrateOptionSet(optionSet: Record<string, any>) {
  if (!optionSet?.options || !Object.keys(optionSet.options).length) {
    return optionSet;
  }

  for (const id in optionSet.options) {
    optionSet.options[id].entityType = "OPTION";
  }

  return optionSet;
}

export default migration_0_0_483;
